import { IconSvg } from '../../types'

export const TentIcon: IconSvg = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.50973 3.1286C9.99109 2.85784 10.6008 3.02856 10.8716 3.50992L12 5.51601L13.1284 3.50992C13.3992 3.02856 14.0089 2.85784 14.4903 3.1286C14.9716 3.39937 15.1423 4.00908 14.8716 4.49044L13.1473 7.55574L19.5849 19.0002H20C20.5523 19.0002 21 19.448 21 20.0002C21 20.5525 20.5523 21.0002 20 21.0002H19.0158C19.0059 21.0004 18.9959 21.0004 18.986 21.0002H13.5C13.2239 21.0002 13 20.7764 13 20.5002V17.0002C13 16.448 12.5523 16.0002 12 16.0002C11.4477 16.0002 11 16.448 11 17.0002V20.5002C11 20.7764 10.7761 21.0002 10.5 21.0002H5.01397C5.00406 21.0004 4.99414 21.0004 4.98421 21.0002H4C3.44772 21.0002 3 20.5525 3 20.0002C3 19.448 3.44772 19.0002 4 19.0002H4.41512L10.8527 7.55574L9.12842 4.49044C8.85766 4.00908 9.02838 3.39937 9.50973 3.1286Z"
        fill="currentColor"
      />
    </svg>
  )
}
